import { useIntl } from '@capsicum/common';
import { CheckboxInput } from '@capsicum/common-web';

import { CheckboxText } from './Register.styled';

export const MarketingConcent = () => {
	const { $t } = useIntl();

	return (
		<CheckboxInput name="marketingConsent" testID="registration-notifications-checkbox">
			<CheckboxText>{$t('auth.signUpEmailNotifications')}</CheckboxText>
		</CheckboxInput>
	);
};
